<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h3>6. Documents annexés au dossier DM au format .pdf</h3>
        <span v-if="!readOnly">
          <v-tooltip bottom color="error">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="error"
                v-bind="attrs"
                v-on="on"
                @click.stop="promptConfirmDeletion()"
              >
                <v-icon>mdi-collapse-all</v-icon>
              </v-btn>
            </template>
            <span>Supprimer tous les documents</span>
          </v-tooltip>

          <v-tooltip bottom color="success">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="success"
                v-bind="attrs"
                v-on="on"
                @click.stop="append"
              >
                <v-icon>mdi-plus-box</v-icon>
              </v-btn>
            </template>
            <span>Ajouter un document</span>
          </v-tooltip>
        </span>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-data-table
        class="mt-0"
        :items="documents"
        :headers="headers"
        no-data-text="Aucun document associé"
        :hide-default-header="!documents[0]"
        hide-default-footer
        dense
        disable-pagination
        disable-sort
        disable-filtering
      >
        <template v-slot:[`item.tri`]="{ index }">
          <v-row
            v-if="documents.length != 1 && !readOnly"
            style="flex-wrap: nowrap"
            align="center"
            justify="space-around"
          >
            <v-btn
              v-if="index != 0"
              icon
              color="info"
              @click.stop="moveUp(index)"
            >
              <v-icon>mdi-arrow-up-bold-circle</v-icon>
            </v-btn>
            <v-btn
              v-if="index != documents.length - 1"
              icon
              color="info"
              @click.stop="moveDown(index)"
            >
              <v-icon>mdi-arrow-down-bold-circle</v-icon>
            </v-btn>
          </v-row>
        </template>
        <template v-slot:[`item.commands`]="{ index }">
          <v-row
            style="flex-wrap: nowrap"
            align="center"
            justify="space-around"
          >
            <v-btn
              :disabled="readOnly"
              icon
              color="error"
              @click.stop="promptConfirmDeletion(index)"
            >
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
          </v-row>
        </template>
        <template v-slot:[`item.fichier`]="{ item }">
          <v-row v-if="item.local">
            <a href="#" @click.prevent="openPdf(item.fileCtl)"
              >{{ item.fileCtl.name }}
            </a>
          </v-row>
          <v-row v-else>
            <a :href="pdfPath + item.fichier" target="_blank">{{
              item.fichier
            }}</a>
          </v-row>
        </template>
        <template v-slot:[`item.fileCtl`]="{ item }">
          <v-row>
            <v-file-input :value="item.fileCtl"></v-file-input>
          </v-row>
        </template>
      </v-data-table>

      <v-dialog persistent v-model="showDelConfirm" max-width="410">
        <v-card>
          <v-card-title class="text-h5">
            Confirmation de suppression
          </v-card-title>
          <v-card-text>
            <div v-if="deleteIndex != null">
              Confirmez-vous la suppression du document
              {{ documentASupprimer }} ?
            </div>
            <div v-else>
              Confirmez-vous la suppression de tous les documents associés ?
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="doDeletion"> Oui </v-btn>
            <v-btn color="success" text @click="cancelDeletion"> Non </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <produit-document-dialog
        :show="showDialog"
        @ok="confirmDocumentDialog"
        @cancel="showDialog = false"
      ></produit-document-dialog>
    </v-row>
  </div>
</template>

<script>
import ProduitDocumentDialog from "@/components/ProduitDocumentDialog";

export default {
  name: "ProduitDocuments",
  components: {
    ProduitDocumentDialog,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        { text: " ", value: "tri" },
        { text: "Document", value: "fichier" },
        { text: "Type", value: "typeDocument" },
        { text: "Contenu", value: "intitule" },
        { text: " ", value: "commands", sortable: false },
        { text: " ", value: "fileCtl", sortable: false, align: " d-none" },
      ],
      showDelConfirm: false,
      deleteIndex: null,
      showDialog: false,
      //   editIndex: null,
    };
  },
  computed: {
    pdfPath() {
      return process.env.VUE_APP_CHEMIN_DOCUMENTS_PDTS;
    },
    documents() {
      return this.$store.state.demandeEditee.produit.documents;
    },
    documentASupprimer() {
      if (this.deleteIndex != null) {
        return this.documents[this.deleteIndex].fichier;
      }
      return "";
    },
    // imageEditee() {
    //   //console.log(this.editIndex);
    //   if (this.editIndex != null) {
    //     return this.images[this.editIndex];
    //   }
    //   return null;
    // },
  },
  methods: {
    promptConfirmDeletion(index = null) {
      // console.log(index);
      this.deleteIndex = index;
      this.showDelConfirm = true;
    },
    doDeletion() {
      if (this.deleteIndex != null) {
        // this.documents.splice(this.deleteIndex, 1);
        this.$store.dispatch("demandeEditee/removeDocument", this.deleteIndex);
        this.deleteIndex = null;
      } else {
        // this.documents.splice(0, this.documents.length);
        this.$store.dispatch("demandeEditee/clearDocuments");
      }
      this.showDelConfirm = false;
    },
    cancelDeletion() {
      this.deleteIndex = null;
      this.showDelConfirm = false;
    },
    confirmDocumentDialog(img) {
      //   if (this.editIndex) {
      //     this.documents.splice(this.editIndex, 1, img);
      //   } else {
      this.$store.dispatch("demandeEditee/addDocument", img);
      //   }
      this.showDialog = false;
    },
    append() {
      //   this.editIndex = null;
      //   this.editedDocument = null;
      this.showDialog = true;
    },
    moveUp(index) {
      this.$store.dispatch("demandeEditee/moveDocumentUp", index);
    },
    moveDown(index) {
      this.$store.dispatch("demandeEditee/moveDocumentDown", index);
    },
    // edit(index) {
    //   this.editIndex = index;
    //   this.showDialog = true;
    // },
    openPdf(fileCtl) {
      fileCtl
        .arrayBuffer()
        .then((bytes) => {
          let blob = new Blob([bytes], { type: "application/pdf" });
          let url = window.URL.createObjectURL(blob);
          window.open(url);
        })
        .catch((err) => {
          this.$store.dispatch("setErreur", err);
        });
      // let datauri = "data:application/pdf;base64," + ;
      // let win = window.open();
      // win.document.location.href = datauri;
    },
  },
};
</script>

<style scoped>
h3 {
  display: inline-block;
  margin-right: 2em;
}
</style>
